export default __webpack_public_path__ + "images/inspection-bg.png?f97e7e959d30c3aa483f499098e1ff99";